import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';
import useFetch from '../useFetch';
import { useNavigate } from 'react-router-dom';
import handleBackendResponse from '../../Utils/handleNotifications/handleBackendResponse';

const handleRawSchedule = (rawSchedule) => {
    const schedule = Object.keys(rawSchedule).map((key, index) => {
        return {
            day: index,
            employeeScheduleTime: rawSchedule[key].map(({ startTime, endTime }) => ({
                startTime: startTime || null,
                endTime: endTime || null,
            }))
        };
    });
    return schedule;
}  
export default function useHandleScedule(userId) {
    const navigate = useNavigate()
        , fetch = useFetch(navigate);

    const { data, error, mutate } = useSWR(`${apiBaseURL}/api/EmployeeSchedule?id=${userId}`, {
        onSuccess: (data) => console.log('Employee schedule fetched successfully:', data),
        revalidateOnFocus: false,
        dedupingInterval: 300000,
    });
    const scheduleData = data?.data?.schedule

    const handlePostAddSchedule = async (rawSchedule) => {
        const schedule = handleRawSchedule(rawSchedule);
        const body = {
            employeeId: userId,
            schedule
        }
        const response = await fetch.post(`${apiBaseURL}/api/EmployeeSchedule`, body);
   
        const isDataGood = handleBackendResponse(response);

        if (isDataGood) await mutate();

        return isDataGood;
    }
    
    const handlePutEditSchedule = async (rawSchedule) => {
        const schedule = handleRawSchedule(rawSchedule);
        const body = {
            employeeId: userId,
            schedule
        }
        const response = await fetch.put(`${apiBaseURL}/api/EmployeeSchedule`, body);
        const isDataGood = handleBackendResponse(response);

        if (isDataGood) await mutate();

        return isDataGood;
    }

    return {
        scheduleData,
        error,
        mutate,
        handlePostAddSchedule,
        handlePutEditSchedule,
    }
}